/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowDecisionOutcome } from './ShadowDecisionOutcome';
import {
    ShadowDecisionOutcomeFromJSON,
    ShadowDecisionOutcomeFromJSONTyped,
    ShadowDecisionOutcomeToJSON,
    ShadowDecisionOutcomeToJSONTyped,
} from './ShadowDecisionOutcome';
import type { ShadowAdmissionNextSteps } from './ShadowAdmissionNextSteps';
import {
    ShadowAdmissionNextStepsFromJSON,
    ShadowAdmissionNextStepsFromJSONTyped,
    ShadowAdmissionNextStepsToJSON,
    ShadowAdmissionNextStepsToJSONTyped,
} from './ShadowAdmissionNextSteps';
import type { ShadowThresholdMode } from './ShadowThresholdMode';
import {
    ShadowThresholdModeFromJSON,
    ShadowThresholdModeFromJSONTyped,
    ShadowThresholdModeToJSON,
    ShadowThresholdModeToJSONTyped,
} from './ShadowThresholdMode';
import type { ShadowComponentCriterionDetail } from './ShadowComponentCriterionDetail';
import {
    ShadowComponentCriterionDetailFromJSON,
    ShadowComponentCriterionDetailFromJSONTyped,
    ShadowComponentCriterionDetailToJSON,
    ShadowComponentCriterionDetailToJSONTyped,
} from './ShadowComponentCriterionDetail';
import type { ShadowAdmissionReasoning } from './ShadowAdmissionReasoning';
import {
    ShadowAdmissionReasoningFromJSON,
    ShadowAdmissionReasoningFromJSONTyped,
    ShadowAdmissionReasoningToJSON,
    ShadowAdmissionReasoningToJSONTyped,
} from './ShadowAdmissionReasoning';
import type { ShadowInsuranceRuleResult } from './ShadowInsuranceRuleResult';
import {
    ShadowInsuranceRuleResultFromJSON,
    ShadowInsuranceRuleResultFromJSONTyped,
    ShadowInsuranceRuleResultToJSON,
    ShadowInsuranceRuleResultToJSONTyped,
} from './ShadowInsuranceRuleResult';
import type { ShadowDealbreakerFlag } from './ShadowDealbreakerFlag';
import {
    ShadowDealbreakerFlagFromJSON,
    ShadowDealbreakerFlagFromJSONTyped,
    ShadowDealbreakerFlagToJSON,
    ShadowDealbreakerFlagToJSONTyped,
} from './ShadowDealbreakerFlag';
import type { ShadowSubsystemResults } from './ShadowSubsystemResults';
import {
    ShadowSubsystemResultsFromJSON,
    ShadowSubsystemResultsFromJSONTyped,
    ShadowSubsystemResultsToJSON,
    ShadowSubsystemResultsToJSONTyped,
} from './ShadowSubsystemResults';

/**
 * Pass-through of the latest shadow_admission_decisions row for a lead.
 * Returns has_shadow_decision=false (and no other fields) when no row exists.
 * 
 * @export
 * @interface ShadowDecision
 */
export interface ShadowDecision {
    /**
     * 
     */
    has_shadow_decision: boolean;
    /**
     * 
     */
    shadow_decision?: ShadowDecisionOutcome;
    /**
     * 
     */
    aggregate_score?: number;
    /**
     * 
     */
    threshold_used?: number;
    /**
     * 
     */
    threshold_mode?: ShadowThresholdMode;
    /**
     * 
     */
    reasoning?: ShadowAdmissionReasoning;
    /**
     * 
     */
    next_steps?: ShadowAdmissionNextSteps;
    /**
     * 
     */
    subsystem_results?: ShadowSubsystemResults;
    /**
     * 
     */
    dealbreaker_flags?: Array<ShadowDealbreakerFlag>;
    /**
     * 
     */
    component_detail?: Array<ShadowComponentCriterionDetail>;
    /**
     * 
     */
    model_name?: string;
    /**
     * 
     */
    analysis_results_count?: number;
    /**
     * 
     */
    date_created?: string;
    /**
     * Typed insurance rule results for this decision, in catalog order.
     * Empty when the decision has no rows (dual-write off, or no rules evaluated).
     * 
     */
    insurance_rule_results?: Array<ShadowInsuranceRuleResult>;
}



/**
 * Check if a given object implements the ShadowDecision interface.
 */
export function instanceOfShadowDecision(value: object): value is ShadowDecision {
    if (!('has_shadow_decision' in value) || value['has_shadow_decision'] === undefined) return false;
    return true;
}

export function ShadowDecisionFromJSON(json: any): ShadowDecision {
    return ShadowDecisionFromJSONTyped(json, false);
}

export function ShadowDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowDecision {
    if (json == null) {
        return json;
    }
    return {
        
        'has_shadow_decision': json['has_shadow_decision'],
        'shadow_decision': json['shadow_decision'] == null ? undefined : ShadowDecisionOutcomeFromJSON(json['shadow_decision']),
        'aggregate_score': json['aggregate_score'] == null ? undefined : json['aggregate_score'],
        'threshold_used': json['threshold_used'] == null ? undefined : json['threshold_used'],
        'threshold_mode': json['threshold_mode'] == null ? undefined : ShadowThresholdModeFromJSON(json['threshold_mode']),
        'reasoning': json['reasoning'] == null ? undefined : ShadowAdmissionReasoningFromJSON(json['reasoning']),
        'next_steps': json['next_steps'] == null ? undefined : ShadowAdmissionNextStepsFromJSON(json['next_steps']),
        'subsystem_results': json['subsystem_results'] == null ? undefined : ShadowSubsystemResultsFromJSON(json['subsystem_results']),
        'dealbreaker_flags': json['dealbreaker_flags'] == null ? undefined : ((json['dealbreaker_flags'] as Array<any>).map(ShadowDealbreakerFlagFromJSON)),
        'component_detail': json['component_detail'] == null ? undefined : ((json['component_detail'] as Array<any>).map(ShadowComponentCriterionDetailFromJSON)),
        'model_name': json['model_name'] == null ? undefined : json['model_name'],
        'analysis_results_count': json['analysis_results_count'] == null ? undefined : json['analysis_results_count'],
        'date_created': json['date_created'] == null ? undefined : json['date_created'],
        'insurance_rule_results': json['insurance_rule_results'] == null ? undefined : ((json['insurance_rule_results'] as Array<any>).map(ShadowInsuranceRuleResultFromJSON)),
    };
}

export function ShadowDecisionToJSON(json: any): ShadowDecision {
    return ShadowDecisionToJSONTyped(json, false);
}

export function ShadowDecisionToJSONTyped(value?: ShadowDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'has_shadow_decision': value['has_shadow_decision'],
        'shadow_decision': ShadowDecisionOutcomeToJSON(value['shadow_decision']),
        'aggregate_score': value['aggregate_score'],
        'threshold_used': value['threshold_used'],
        'threshold_mode': ShadowThresholdModeToJSON(value['threshold_mode']),
        'reasoning': ShadowAdmissionReasoningToJSON(value['reasoning']),
        'next_steps': ShadowAdmissionNextStepsToJSON(value['next_steps']),
        'subsystem_results': ShadowSubsystemResultsToJSON(value['subsystem_results']),
        'dealbreaker_flags': value['dealbreaker_flags'] == null ? undefined : ((value['dealbreaker_flags'] as Array<any>).map(ShadowDealbreakerFlagToJSON)),
        'component_detail': value['component_detail'] == null ? undefined : ((value['component_detail'] as Array<any>).map(ShadowComponentCriterionDetailToJSON)),
        'model_name': value['model_name'],
        'analysis_results_count': value['analysis_results_count'],
        'date_created': value['date_created'],
        'insurance_rule_results': value['insurance_rule_results'] == null ? undefined : ((value['insurance_rule_results'] as Array<any>).map(ShadowInsuranceRuleResultToJSON)),
    };
}

